import { render, staticRenderFns } from "./accountsReceive.vue?vue&type=template&id=005a50a6&scoped=true"
import script from "./accountsReceive.vue?vue&type=script&lang=js"
export * from "./accountsReceive.vue?vue&type=script&lang=js"
import style0 from "./accountsReceive.vue?vue&type=style&index=0&id=005a50a6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005a50a6",
  null
  
)

export default component.exports